if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    console.log('INIT THEME CUSTOM FEATURES: DOMContentLoaded');
    initThemeCustomFeatures(document);
  });
} else {
  console.log('INIT THEME CUSTOM FEATURES: immediate');
  initThemeCustomFeatures(document);
}

document.addEventListener('shopify:section:load', function (event) {
  console.log('INIT THEME CUSTOM FEATURES: section load');
  initThemeCustomFeatures(event.target);
});

function initThemeCustomFeatures(root) {
  initMultiColumnVideos(root);
  initTabbedColumns(root);
  initProductCardVariantSwatches(root);
  initProductCardAjaxForms(root);
}

function initTabbedColumns(root) {
  var scope = root || document;

  scope.querySelectorAll('.gm-tabbed-column').forEach(function (rootEl) {
    if (rootEl.dataset.tabsInitialized === 'true') return;
    rootEl.dataset.tabsInitialized = 'true';

    var triggers = rootEl.querySelectorAll('[data-tab-trigger]');
    var panels = rootEl.querySelectorAll('[data-tab-panel]');
    var defaultTab = rootEl.getAttribute('data-default-tab') || '1';

    function setTab(tabId) {
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === tabId);
      });

      triggers.forEach(function (trigger) {
        var isActive = trigger.getAttribute('data-tab-trigger') === tabId;
        var activeBg = trigger.getAttribute('data-active-bg');
        var activeText = trigger.getAttribute('data-active-text');
        var inactiveBg = trigger.getAttribute('data-inactive-bg');
        var inactiveText = trigger.getAttribute('data-inactive-text');

        trigger.style.background = isActive ? activeBg : inactiveBg;
        trigger.style.color = isActive ? activeText : inactiveText;
        trigger.style.borderColor = isActive ? activeBg : inactiveText;
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        setTab(trigger.getAttribute('data-tab-trigger'));
      });
    });

    setTab(defaultTab);
  });
}

function initMultiColumnVideos(root) {
  var scope = root || document;
  var triggers = scope.querySelectorAll('[data-multi-column-video-trigger]');

  triggers.forEach(function (trigger) {
    if (trigger.dataset.videoInitialized === 'true') return;
    trigger.dataset.videoInitialized = 'true';

    trigger.addEventListener('click', function () {
      var figure = trigger.closest('.multi-column__grid-item-image-figure');
      if (!figure) return;

      var template = figure.querySelector('[data-multi-column-video-template]');
      if (!template) return;

      openMultiColumnVideoLightbox(template.innerHTML);
    });
  });
}

function openMultiColumnVideoLightbox(html) {
  var existing = document.querySelector('.multi-column-video-lightbox');
  if (existing) existing.remove();

  var wrapper = document.createElement('div');
  wrapper.className = 'multi-column-video-lightbox';
  wrapper.innerHTML =
    '<div class="modal active multi-column-video-modal">' +
      '<div class="modal__wash" data-mcv-close></div>' +
      '<div class="modal__inner multi-column-video-modal__inner" data-scroll-lock-ignore>' +
        '<div class="modal__header">' +
          '<button type="button" class="modal__close-icon multi-column-video-modal__close" data-mcv-close aria-label="Cerrar">×</button>' +
        '</div>' +
        '<div class="modal__content multi-column-video-modal__content">' + html + '</div>' +
      '</div>' +
    '</div>';

  document.body.appendChild(wrapper);
  document.body.classList.add('mcv-lightbox-open');

  bindMultiColumnVideoPlayers(wrapper);
  bindMultiColumnLightboxClose(wrapper);
}

function bindMultiColumnLightboxClose(wrapper) {
  wrapper.querySelectorAll('[data-mcv-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      closeMultiColumnVideoLightbox(wrapper);
    });
  });

  function handleEscape(event) {
    if (event.key === 'Escape') {
      closeMultiColumnVideoLightbox(wrapper);
      document.removeEventListener('keydown', handleEscape);
    }
  }

  document.addEventListener('keydown', handleEscape);
}

function closeMultiColumnVideoLightbox(wrapper) {
  var iframe = wrapper.querySelector('iframe');
  var video = wrapper.querySelector('video');

  if (video) {
    video.pause();
  }

  if (iframe) {
    iframe.src = iframe.src;
  }

  wrapper.remove();
  document.body.classList.remove('mcv-lightbox-open');
}

function bindMultiColumnVideoPlayers(wrapper) {
  var external = wrapper.querySelector('.multi-column__lightbox-video[data-video-provider][data-video-id]');
  var nativeVideo = wrapper.querySelector('video');

  if (nativeVideo) {
    nativeVideo.play().catch(function () {});
    return;
  }

  if (!external) return;

  var provider = external.getAttribute('data-video-provider');
  var videoId = external.getAttribute('data-video-id');

  if (provider === 'youtube') {
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&playsinline=1';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.setAttribute('frameborder', '0');
    external.replaceWith(iframe);
    return;
  }

  if (provider === 'vimeo') {
    var iframe = document.createElement('iframe');
    iframe.src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.setAttribute('frameborder', '0');
    external.replaceWith(iframe);
  }
}

var PRODUCT_CARD_SELECTOR = '[data-product-card], .product-item';
var PRODUCT_CARD_FORM_SELECTOR =
  '[data-product-card] [data-product-form], .product-item [data-product-form]';

function getProductCardVariantControl(card) {
  return card.querySelector(
    '[data-variant-select], select[name="id"], input[name="id"]'
  );
}

function initProductCardVariantSwatches(root) {
  var scope = root || document;
  var productCards = [];

  if (
    scope.matches &&
    scope.matches(PRODUCT_CARD_SELECTOR)
  ) {
    productCards = [scope];
  } else {
    productCards = Array.from(
      scope.querySelectorAll(PRODUCT_CARD_SELECTOR)
    );
  }

  productCards.forEach(function (card) {
    syncProductCardFromSelect(card);

    var variantSelect = getProductCardVariantControl(card);

    if (
      variantSelect &&
      !variantSelect.dataset.variantSelectBound
    ) {
      variantSelect.dataset.variantSelectBound = 'true';

      variantSelect.addEventListener('change', function () {
        syncProductCardFromSelect(card);
      });
    }
  });
}

function initProductCardAjaxForms(root) {
  var scope = root || document;
  var forms = [];

  if (
    scope.matches &&
    scope.matches('[data-product-form]') &&
    scope.closest(PRODUCT_CARD_SELECTOR)
  ) {
    forms = [scope];
  } else {
    forms = Array.from(
      scope.querySelectorAll(PRODUCT_CARD_FORM_SELECTOR)
    );
  }

  forms.forEach(function (form) {
    if (form.dataset.gmAjaxCartBound === 'true') {
      return;
    }

    form.dataset.gmAjaxCartBound = 'true';

    form.addEventListener(
      'submit',
      handleProductCardAjaxSubmit,
      true
    );
  });
}

function handleProductCardAjaxSubmit(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  var form = event.currentTarget;

  if (
    !form ||
    form.dataset.gmAjaxSubmitting === 'true'
  ) {
    return;
  }

  var button = form.querySelector('[data-add-to-cart]');

  if (
    button &&
    (
      button.disabled ||
      button.getAttribute('aria-disabled') === 'true'
    )
  ) {
    return;
  }

  var variantControl = form.querySelector(
    '[data-variant-select], select[name="id"], input[name="id"]'
  );

  if (!variantControl || !variantControl.value) {
    console.error(
      'No se encontró una variante válida en el formulario.',
      form
    );
    return;
  }

  form.dataset.gmAjaxSubmitting = 'true';

  var buttonText = form.querySelector(
    '[data-add-to-cart-text]'
  );

  var originalText = buttonText
    ? buttonText.textContent
    : '';

  var originalDisabled = button
    ? button.disabled
    : false;

  if (button) {
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');
  }

  if (buttonText) {
    buttonText.textContent =
      button &&
      button.getAttribute('data-lang-loading')
        ? button.getAttribute('data-lang-loading')
        : 'Adding...';
  }

  var formData = new FormData(form);

  if (!formData.get('id')) {
    formData.set('id', variantControl.value);
  }

  fetch(getShopifyRoot() + 'cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: formData
  })
    .then(parseJsonResponse)
    .then(function (addedItem) {
      if (buttonText) {
        buttonText.textContent =
          button &&
          button.getAttribute('data-lang-added')
            ? button.getAttribute('data-lang-added')
            : 'Added';
      }

      notifyStilettoProductAdded(addedItem);
    })
    .catch(function (error) {
      console.error(
        'No se pudo añadir el producto:',
        error
      );

      document.dispatchEvent(
        new CustomEvent('cart:error', {
          bubbles: true,
          detail: {
            errorMessage: error.message
          }
        })
      );

      window.alert(
        error.message ||
        'The product could not be added.'
      );
    })
    .finally(function () {
      form.dataset.gmAjaxSubmitting = 'false';

      window.setTimeout(function () {
        if (button) {
          button.disabled = originalDisabled;

          if (originalDisabled) {
            button.setAttribute(
              'aria-disabled',
              'true'
            );
          } else {
            button.removeAttribute(
              'aria-disabled'
            );
          }

          button.classList.remove('is-loading');
        }

        if (buttonText) {
          buttonText.textContent = originalText;
        }

        var card = form.closest(
          PRODUCT_CARD_SELECTOR
        );

        if (card) {
          syncProductCardFromSelect(card);
        }
      }, 500);
    });
}

function parseJsonResponse(response) {
  return response
    .json()
    .catch(function () {
      return {};
    })
    .then(function (data) {
      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          'The product could not be added.'
        );
      }

      return data;
    });
}

function getShopifyRoot() {
  var root =
    window.Shopify &&
    Shopify.routes &&
    Shopify.routes.root
      ? Shopify.routes.root
      : '/';

  return root.charAt(root.length - 1) === '/'
    ? root
    : root + '/';
}

function notifyStilettoProductAdded(addedItem) {
  var opened = false;
  var fallbackTimer = null;
  var cleanupTimer = null;

  function cleanup() {
    document.removeEventListener(
      'cart:updated',
      handleCartUpdated
    );

    document.removeEventListener(
      'quick-cart:open',
      handleCartFeedbackOpened
    );

    if (fallbackTimer) {
      window.clearTimeout(fallbackTimer);
    }

    if (cleanupTimer) {
      window.clearTimeout(cleanupTimer);
    }
  }

  function handleCartFeedbackOpened() {
    opened = true;
    cleanup();
  }

  function handleCartUpdated() {
    window.requestAnimationFrame(function () {
      openNativeCartFeedback();
    });
  }

  document.addEventListener(
    'cart:updated',
    handleCartUpdated,
    { once: true }
  );

  document.addEventListener(
    'quick-cart:open',
    handleCartFeedbackOpened
  );

  /*
   * Evento oficial de Stiletto para refrescar el Quick Cart
   * y el contador del encabezado después de una adición AJAX.
   */
  document.dispatchEvent(
    new CustomEvent(
      'apps:product-added-to-cart'
    )
  );

  document.dispatchEvent(
    new CustomEvent('gm:product-added-to-cart', {
      bubbles: true,
      detail: {
        product: addedItem
      }
    })
  );

  /*
   * Stiletto escucha apps:product-added-to-cart para
   * refrescar el carrito y su contador. Si la configuración
   * del tema no abre automáticamente el drawer o el popup,
   * usamos el icono nativo del carrito como respaldo.
   */
  fallbackTimer = window.setTimeout(
    function () {
      if (!opened && !isCartFeedbackVisible()) {
        openNativeCartFeedback();
      }
    },
    900
  );

  cleanupTimer = window.setTimeout(
    cleanup,
    2500
  );
}

function isCartFeedbackVisible() {
  var quickCart = document.querySelector(
    '.quick-cart__wrapper'
  );

  var confirmationPopup = document.querySelector(
    '.purchase-confirmation-popup'
  );

  var quickCartVisible =
    quickCart &&
    (
      quickCart.classList.contains('active') ||
      quickCart.getAttribute('aria-hidden') === 'false'
    );

  var popupVisible =
    confirmationPopup &&
    confirmationPopup.classList.contains('active');

  return Boolean(
    quickCartVisible || popupVisible
  );
}

function openNativeCartFeedback() {
  if (isCartFeedbackVisible()) {
    return;
  }

  var cartIcon = document.querySelector(
    '[data-js-cart-icon]'
  );

  var trigger = cartIcon
    ? cartIcon.closest(
        'button, a, [role="button"]'
      )
    : null;

  if (!trigger) {
    trigger = document.querySelector(
      '[data-quick-cart-trigger], ' +
      '[data-cart-trigger], ' +
      'a[href="/cart"][aria-controls]'
    );
  }

  if (trigger && typeof trigger.click === 'function') {
    trigger.click();
    return;
  }

  /*
   * Último respaldo: si el tema no ofrece ningún trigger
   * reconocible, llevamos al carrito normal para no dejar
   * al cliente sin feedback.
   */
  window.location.href = getShopifyRoot() + 'cart';
}

function normalizeProductOptionValue(value) {
  return String(value == null ? '' : value)
    .trim()
    .toLowerCase()
    .replace(/&nbsp;/g, ' ')
    .replace(/[\s_-]+/g, ' ');
}

function productOptionValuesEqual(firstValue, secondValue) {
  return normalizeProductOptionValue(firstValue) ===
    normalizeProductOptionValue(secondValue);
}

function getSelectedProductCardVariant(card, variants) {
  var variantControl = getProductCardVariantControl(card);

  if (variantControl && variantControl.value) {
    var selectedVariant = variants.find(function (variant) {
      return String(variant.id) === String(variantControl.value);
    });

    if (selectedVariant) return selectedVariant;
  }

  return getCurrentVariantFromCard(card, variants);
}

function inferProductCardSwatchOptionIndex(card, variants) {
  if (!variants.length || !variants[0].options) return -1;

  var optionCount = variants[0].options.length;
  var swatchValues = Array.from(
    card.querySelectorAll(
      '.product-swatches-options__item[data-option-value]'
    )
  ).map(function (item) {
    return normalizeProductOptionValue(
      item.getAttribute('data-option-value')
    );
  }).filter(Boolean);

  var rawIndexElement = card.querySelector(
    '.product-swatches-options__item[data-option-index]'
  );

  var rawIndex = rawIndexElement
    ? parseInt(
        rawIndexElement.getAttribute('data-option-index') || '-1',
        10
      )
    : -1;

  var bestIndex = -1;
  var bestScore = -1;

  for (var optionIndex = 0; optionIndex < optionCount; optionIndex += 1) {
    var variantValues = variants.map(function (variant) {
      return variant.options
        ? normalizeProductOptionValue(variant.options[optionIndex])
        : '';
    });

    var score = swatchValues.reduce(function (total, swatchValue) {
      return total + (variantValues.indexOf(swatchValue) !== -1 ? 1 : 0);
    }, 0);

    if (score > bestScore) {
      bestScore = score;
      bestIndex = optionIndex;
    }
  }

  if (bestScore > 0) return bestIndex;

  if (rawIndex >= 0 && rawIndex < optionCount) {
    return rawIndex;
  }

  if (rawIndex > 0 && rawIndex - 1 < optionCount) {
    return rawIndex - 1;
  }

  return optionCount === 1 ? 0 : -1;
}

function findProductCardVariantForSwatch(card, trigger, variants) {
  var optionValue = trigger.getAttribute('data-option-value');
  if (!optionValue) return null;

  var currentVariant = getSelectedProductCardVariant(card, variants);
  if (!currentVariant || !currentVariant.options) return null;

  var optionIndex = inferProductCardSwatchOptionIndex(card, variants);
  if (optionIndex < 0 || optionIndex >= currentVariant.options.length) {
    return null;
  }

  var nextOptions = currentVariant.options.slice();
  nextOptions[optionIndex] = optionValue;

  var matchedVariant = variants.find(function (variant) {
    if (
      !variant.options ||
      variant.options.length !== nextOptions.length
    ) {
      return false;
    }

    return variant.options.every(function (value, index) {
      return productOptionValuesEqual(value, nextOptions[index]);
    });
  });

  if (!matchedVariant) {
    matchedVariant = variants.find(function (variant) {
      return (
        variant.options &&
        productOptionValuesEqual(
          variant.options[optionIndex],
          optionValue
        )
      );
    });
  }

  return matchedVariant || null;
}

function handleProductCardSwatchClick(card, trigger) {
  var variants = getProductCardVariants(card);

  if (!variants.length) {
    console.warn(
      'No se encontraron variantes en la tarjeta del producto.',
      card
    );
    return;
  }

  var matchedVariant = findProductCardVariantForSwatch(
    card,
    trigger,
    variants
  );

  if (!matchedVariant) {
    console.warn(
      'No se encontró una variante para el swatch seleccionado.',
      {
        value: trigger.getAttribute('data-option-value'),
        index: trigger.getAttribute('data-option-index'),
        card: card
      }
    );
    return;
  }

  /* Feedback inmediato antes de disparar el cambio del select. */
  syncProductCardUI(card, matchedVariant);
  card.dataset.initialVariantId = String(matchedVariant.id);

  var variantSelect = getProductCardVariantControl(card);

  if (variantSelect) {
    variantSelect.value = String(matchedVariant.id);
    variantSelect.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }
}

function syncProductCardFromSelect(card) {
  var variants = getProductCardVariants(card);
  if (!variants.length) return;

  var variantSelect = getProductCardVariantControl(card);
  var selectedVariant = null;

  if (variantSelect && variantSelect.value) {
    selectedVariant = variants.find(function (variant) {
      return String(variant.id) === String(variantSelect.value);
    });
  }

  if (!selectedVariant) {
    selectedVariant = getCurrentVariantFromCard(card, variants);
  }

  if (!selectedVariant) return;

  card.dataset.initialVariantId = String(selectedVariant.id);
  syncProductCardUI(card, selectedVariant);
}

function syncProductCardUI(card, variant) {
  updateProductCardSwatches(card, variant);
  updateProductCardPrice(card, variant);
  updateProductCardButton(card, variant);
  updateProductCardForm(card, variant);
  updateProductCardImage(card, variant);
  updateProductCardPaymentTerms(card, variant);
}

function updateProductCardSwatches(card, variant) {
  if (!variant || !variant.options) return;

  var variants = getProductCardVariants(card);
  var optionIndex = inferProductCardSwatchOptionIndex(
    card,
    variants.length ? variants : [variant]
  );

  if (optionIndex < 0 || optionIndex >= variant.options.length) {
    return;
  }

  var selectedValue = variant.options[optionIndex];
  var items = card.querySelectorAll(
    '.product-swatches-options__item[data-option-value]'
  );

  items.forEach(function (item) {
    var optionValue = item.getAttribute('data-option-value');
    var isActive = productOptionValuesEqual(
      selectedValue,
      optionValue
    );

    item.classList.toggle('is-active', isActive);
    item.setAttribute(
      'aria-pressed',
      isActive ? 'true' : 'false'
    );
  });
}

function updateProductCardPrice(card, variant) {
  var priceWrap = card.querySelector('[data-product-price]');
  if (!priceWrap || !variant) return;

  var price = formatMoneyFromCents(variant.price);
  var compareAtPrice = variant.compare_at_price ? formatMoneyFromCents(variant.compare_at_price) : '';

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    priceWrap.innerHTML =
      '<p class="product-item__price">' +
        '<s class="t-subdued">' + escapeHtml(compareAtPrice) + '</s> ' +
        '<span class="sale">' + escapeHtml(price) + '</span>' +
      '</p>';
  } else {
    priceWrap.innerHTML =
      '<p class="product-item__price">' +
        '<span class="product-item__price">' + escapeHtml(price) + '</span>' +
      '</p>';
  }
}

function updateProductCardButton(card, variant) {
  var addToCartButton = card.querySelector('[data-add-to-cart]');
  var addToCartText = card.querySelector('[data-add-to-cart-text]');
  if (!addToCartButton || !addToCartText || !variant) return;

  if (variant.available) {
    addToCartButton.disabled = false;
    addToCartButton.removeAttribute('disabled');
    addToCartButton.removeAttribute('aria-disabled');
    addToCartText.textContent = addToCartButton.getAttribute('data-lang-available') || 'Add to cart';
  } else {
    addToCartButton.disabled = true;
    addToCartButton.setAttribute('disabled', 'disabled');
    addToCartButton.setAttribute('aria-disabled', 'true');
    addToCartText.textContent = addToCartButton.getAttribute('data-lang-sold-out') || 'Sold out';
  }
}

function updateProductCardForm(card, variant) {
  var form = card.querySelector('[data-product-form]');
  if (form) {
    form.setAttribute('data-current-product-id', String(variant.id));
  }

  var variantSelect = getProductCardVariantControl(card);
  if (variantSelect) {
    variantSelect.value = String(variant.id);
  }
}

function updateProductCardImage(card, variant) {
  if (!variant) return;

  var featuredImage = variant.featured_image;
  var featuredMedia = variant.featured_media;
  var imageLink = card.querySelector('.product-item__image-link');
  if (!imageLink) return;

  var primaryImg = imageLink.querySelector('.image__img');
  if (!primaryImg) return;

  var imageData = null;

  if (featuredImage && featuredImage.src) {
    imageData = {
      src: featuredImage.src,
      alt: featuredImage.alt || variant.name || ''
    };
  } else if (
    featuredMedia &&
    featuredMedia.preview_image &&
    featuredMedia.preview_image.src
  ) {
    imageData = {
      src: featuredMedia.preview_image.src,
      alt: featuredMedia.alt || variant.name || ''
    };
  }

  if (!imageData) return;

  var normalizedSrc = normalizeShopifyImageUrl(imageData.src);

  primaryImg.src = addWidthToShopifyImage(normalizedSrc, 600);
  primaryImg.srcset = '';
  primaryImg.alt = imageData.alt;

  var primaryWrapper = primaryImg.closest('.image');
  if (primaryWrapper) {
    primaryWrapper.classList.add('loaded');
  }
}

function updateProductCardPaymentTerms(card, variant) {
  if (!variant) return;

  var paymentTerms = card.querySelector('shopify-payment-terms');
  if (!paymentTerms) return;

  paymentTerms.setAttribute('variant-id', String(variant.id));
}

function getProductCardVariants(card) {
  var script = card.querySelector('[data-product-variants]');
  if (!script) return [];

  try {
    return JSON.parse(script.textContent.trim());
  } catch (error) {
    console.error('No se pudo parsear variantes del product card', error);
    return [];
  }
}

function getCurrentVariantFromCard(card, variants) {
  var currentVariantId = card.getAttribute('data-initial-variant-id');

  if (currentVariantId) {
    var matched = variants.find(function (variant) {
      return String(variant.id) === String(currentVariantId);
    });

    if (matched) return matched;
  }

  return variants[0] || null;
}

function formatMoneyFromCents(cents) {
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    if (window.theme && window.theme.moneyFormat) {
      return Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return Shopify.formatMoney(cents);
  }

  return '$' + (Number(cents || 0) / 100).toFixed(2);
}

function normalizeShopifyImageUrl(src) {
  if (!src) return '';

  if (src.indexOf('//') === 0) {
    return window.location.protocol + src;
  }

  return src;
}

function addWidthToShopifyImage(src, width) {
  if (!src) return '';

  var cleanSrc = src.split('?')[0];
  return cleanSrc + '?width=' + width;
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

if (!window.__gmProductCardSwatchDelegationBound) {
  window.__gmProductCardSwatchDelegationBound = true;

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var trigger = event.target.closest(
      '.product-swatches-options__item[data-option-value]'
    );

    if (!trigger || trigger.disabled) return;

    var card = trigger.closest(PRODUCT_CARD_SELECTOR);

    if (!card) {
      console.warn(
        'No se encontró la tarjeta del producto para el swatch',
        trigger
      );
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    handleProductCardSwatchClick(card, trigger);
  }, true);
}


function bindProductCardObserver() {
  if (
    window.__gmProductCardObserverBound ||
    !document.body
  ) {
    return;
  }

  window.__gmProductCardObserverBound = true;

  var productCardObserver = new MutationObserver(
    function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) {
            return;
          }

          if (
            node.matches &&
            node.matches(PRODUCT_CARD_SELECTOR)
          ) {
            initThemeCustomFeatures(node);
            return;
          }

          if (
            node.querySelector &&
            node.querySelector(PRODUCT_CARD_SELECTOR)
          ) {
            initThemeCustomFeatures(node);
          }
        });
      });
    }
  );

  productCardObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

if (document.body) {
  bindProductCardObserver();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    bindProductCardObserver,
    { once: true }
  );
}
